import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { InputJson, ShouldHaveAtLeastOneCheck } from 'src/app/shared/helpers/formattedInput';
import { PagesName } from 'src/app/shared/helpers/pagesName';
import { PagesPublicName } from 'src/app/shared/helpers/pagesPublicName';
import { ProjectsService, WorkflowInput, getVisible, isBool, isArray, isMultiple } from 'src/app/api/projects.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LayoutOrganizationService } from 'src/app/api/layout-organization.service';

@Component({
  selector: 'app-project-data-types',
  templateUrl: './project-data-types.component.html',
  styleUrls: ['../project-creation.component.scss', './project-data-types.component.scss']
})
export class ProjectDataTypesComponent implements OnInit {

  @Input() projectId?;
  @Input() workflowId?;
  workflow;
  tagName = 'is_data_types'
  submitted = false;
  inputsInProject = new BehaviorSubject<any>([]);
  inputsInWorkflow = new BehaviorSubject<any>(null);
  form: FormGroup
  fieldObjects = new BehaviorSubject<any>([]);
  PagesPublicName = PagesPublicName
  workflowInputsSubscription: Subscription;
  projectInputsSubscription: Subscription;
  filegroupId;
  filteredSubjects = new BehaviorSubject<any>([])
  fieldName;
  dataTypesArray;
  diseaseMetadata
  dataTypeMetadata
  constructor(public projectsService: ProjectsService,
    private router: Router,
    private route: ActivatedRoute,
    private layout: LayoutOrganizationService) {
    if (!this.projectId)
      _.set(this, 'projectId', this.route.snapshot.paramMap.get('projectId'));
    if (!this.workflowId)
      _.set(this, 'workflowId', this.route.snapshot.paramMap.get('workflowId'));
    if (this.route.snapshot.paramMap.get('country')) {
      _.set(this.projectsService, 'projectStorageCountry', this.route.snapshot.paramMap.get('country'))
    }

    this.route.queryParams.subscribe((params) => {
      if (params['fromDebugger'] === 'false' || !_.get(params, 'fromDebugger')) {
        projectsService.setFromDebugger(false)
      } else if (params['fromDebugger'] === 'true') {
        projectsService.setFromDebugger(true)
      }
      _.set(this, 'filegroupId', params['filegroupId']);
      _.set(this, 'dataTypeMetadata', params['dataTypeMetadata']);
      _.set(this, 'diseaseMetadata', params['diseaseMetadata']);

    })
  }

  ngOnInit(): void {
    this.getWorkflowInputs()

    this.workflowInputsSubscription = this.inputsInWorkflow.subscribe((res) => {
      let fieldObjects = []
      this.getProjectInputs(this.tagName)

      if (_.isEmpty(res)) {
        this.fieldObjects.next(fieldObjects)
        return
      }
      this.form = this.projectsService.createEmptyForm(res);

      for (const [key, value] of Object.entries(res)) {
        let w = value as WorkflowInput
        this.fieldName = key
        this.dataTypesArray = _.words(_.get(w, 'tags.allowed_values', ''), /[^,]+/g)
        let input: InputJson = {
          formControlName: key,
          originalJson: w,
          type: _.get(w, 'type'),
          is_array: _.get(w, 'tags.is_array'),
          multiple_selection: _.get(w, 'tags.multiple_selection'),
          allowed_values: _.words(_.get(w, 'tags.allowed_values', ''), /[^,]+/g),
          allowed_values_descriptions: _.words(_.get(w, 'tags.allowed_values_descriptions', ''), /[^,]+/g),
          fitToContent: true,
          iconClassName: 'fa fa-info-circle',
          validations: _.get(w, 'optional') ? [] : [ShouldHaveAtLeastOneCheck],
          retrievedValue: new BehaviorSubject<any>(undefined),
          tagname: this.tagName
        }
        fieldObjects.unshift(input)
      }
      this.fieldObjects.next(fieldObjects)
      setTimeout(() => { this.onCheck() }, 1)
    })
    this.projectInputsSubscription = this.inputsInProject.subscribe((res) => {
      if (_.isEmpty(res)) {
        return
      }
      this.projectsService.setRetrievedValue(res, this.getFieldObjects())
      setTimeout(() => { this.onCheck() }, 1)
    })
  }

  filterWorkflowInputs(inputs) {
    let newInputs = _.pickBy(inputs, (value, key) => (_.includes(key, 'data_type') || _.includes(key, 'dataType')));
    newInputs = _.pickBy(newInputs, getVisible);
    newInputs = _.pickBy(newInputs, isArray);
    newInputs = _.pickBy(newInputs, isMultiple);
    return newInputs
  }

  getProjectInputs(tagName) {
    this.projectsService.projectGet(this.projectId).subscribe((res) => {
      if (!this.projectsService.getProjectName()) {
        this.projectsService.setProjectName(res.title)
      }
      let inputsInProject = _.get(res, 'input_list', [])
      inputsInProject = this.projectsService.filterProjectInputs(inputsInProject, tagName)
      this.inputsInProject.next(inputsInProject)
    }, () => {
      this.layout.toast('Error when getting projet inputs', null, 8000, '', 'warning')
    })
  }

  getFilteredValue() {
    return _.get(this, 'filteredSubjects.value')
  }

  getWorkflowInputs() {
    this.projectsService.getWorkflow(this.workflowId).subscribe((res) => {
      this.workflow = res
      let inputs = this.filterWorkflowInputs(_.get(res, 'inputs', {}))
      this.inputsInWorkflow.next(inputs)

    }, () => {
      this.inputsInWorkflow.next({})
      this.layout.toast('Error when getting workflow inputs', null, 8000, '', 'warning')
    })
  }

  getFormError() {
    return this.getFormValidity() ? '' : 'Please verify your form.'
  }
  getWorkflowName() {
    return _.get(this, 'workflow.name', null)
  }
  getForm() {
    return _.get(this, 'form', null)
  }
  getFormValidity() {
    return _.get(this, 'form.status', false) === 'VALID'
  }
  getFieldObjects() {
    return _.get(this, 'fieldObjects.value', [])
  }
  getFieldObjectsLength() {
    return _.get(this, 'fieldObjects.value.length', [])
  }
  getInputsInProjects() {
    return _.get(this, 'inputsInProject.value', [])
  }
  onCheck() {
    let answer = _.get(this.getForm(), 'controls[' + this.fieldName + '].value')
    let body = {
      filegroup_id: this.filegroupId,
      disease_filters: this.diseaseMetadata,
    }
    let selectedDataTypes = []
    this.dataTypesArray.forEach((element, index) => {
      if (_.nth(answer, index) === true) {
        selectedDataTypes.push(element)
      }
    });
    if (selectedDataTypes.length) {
      _.set(body, 'data_type', _.join(selectedDataTypes))
    }
    this.dataTypeMetadata = _.join(selectedDataTypes)
    this.projectsService.searchFiles(body).subscribe((res) => {
      this.filteredSubjects.next(_.get(res, 'counts.patients'))

    })
  }

  next() {
    this.submitted = true
    this.projectsService.updateAllInputs(this.projectId, this.getFieldObjects(), this.getInputsInProjects(), this.getForm(), this.tagName).then(() => {
      this.router.navigate([PagesName.ProjectCreation, PagesName.ConfigureWorkflow, this.projectId, this.workflowId, this.projectsService.getProjectStorageCountry()], { queryParams: { fromDebugger: this.projectsService.getFromDebugger(), filegroupId: this.filegroupId, diseaseMetadata: this.diseaseMetadata, dataTypeMetadata: this.dataTypeMetadata } })
    }, () => {
      this.layout.toast('Error when updating inputs', null, 8000, null, 'danger')
    })
  }

  previous() {
    this.submitted = true
    this.router.navigate([PagesName.ProjectCreation, PagesName.ChooseDiseases, this.projectId, this.workflowId, this.projectsService.getProjectStorageCountry()], { queryParams: { fromDebugger: this.projectsService.getFromDebugger(), filegroupId: this.filegroupId, diseaseMetadata: this.diseaseMetadata } })
  }

  ngOnDestroy() {
    this.workflowInputsSubscription.unsubscribe()
    this.projectInputsSubscription.unsubscribe()
  }


}
